<template>
    <div class="body">
        <div v-for="(obj, index) in dataTemplateAPR" v-bind:key="index" style="align-items: center;">
          <b-card no-body class="font-column-matriz-etapa" style="border: none; margin-bottom: 0rem; margin-top: 1rem; display: flex; justify-content: center; align-items: flex-start; border-radius: 0;">
            <div v-if="!isPdf" style="width: 100%;">
              <b-card-header v-on:click="toggleSection(index)" header-tag="header" class="w-100 p-0 mb-0 collapseApr" role="tab">
                <div v-if="!isPdf" variant="info" class="head-mes">
                  <div class="title-left pl-3">
                  <div class="title-colapse-mirror">{{ obj.nomeEtapaServico }}</div>
                  </div>
                  <div class="componente" v-if="!isPdf" style="padding: 0 10px 0 10px;">
                  <i v-if="!openSections.includes(index)" class="fas fa-angle-down arrow-angel"></i>
                  <i v-else class="fas fa-angle-up arrow-angel"></i>
                  </div>
              </div>
              </b-card-header>
            </div>
            <b-collapse
              :visible="openSections.includes(index) || isPdf == true"
              id="id"
              role="tabpanel"
              ref="testeacor"
              class="w-100"
              style="margin-bottom: 0;">
            <div class="pageBreak" v-for="(item, index) in obj.grupo" v-bind:key="item.riscoId">
            <div v-if="isPdf" header-tag="header" style="break-inside: avoid;"  class="w-100 p-0 mb-0 collapseApr" role="tab">
              <div variant="info" class="head-mes">
                  <div class="title-left pl-3">
                  <div class="title-colapse-mirror" style="padding: 0.2rem;">{{ obj.nomeEtapaServico }}</div>
                  </div>
              </div>
            </div>
            <div class="d-flex w-100">
            <div class="Header-Detalhes-Templete" :class="index !== 0 ? 'mt-2' : ''" :style="isPdf === undefined || isPdf === !true ? 'width: 75%;' : 'width: 75%'">
              <div class="d-flex">
                <div class="font font-bold  tipo-apr ml-3">{{item.riscoDescricao}}</div>
              </div>
            </div>
            <div class="Coluna-Detalhes-risco-parte2" :class="index !== 0 ? 'mt-2' : ''" :style="isPdf === undefined || isPdf === !true ? 'width: 15%;' : 'width: 25%'">
              <div class="Colunas-Detalhes-template">
                <div class="font-column-matriz" v-b-tooltip.hover :title="'Severidade'">
                  S
                </div>
                <div class="font-column-matriz" v-b-tooltip.hover :title="'Probabilidade'">
                  P
                </div>
                <div class="font-column-matriz" v-b-tooltip.hover :title="'Cálculo Matriz de Risco'">
                  CR
                </div>
              </div>
            </div>
            <div v-if="isPdf === false || isPdf === undefined" style="width: 10%; background-color: #e4e5e6; border-right: 1px solid #d2d2d2;"></div>
          </div>
            <div class="Detalhes-Templete pageBreak" :class="index !== 0 ? 'mt-2' : ''" v-for="(dataCausa, index) in item.itens" v-bind:key="index">
              <div class="Informacao-Detalhes-template pageBreak">
                <div class="riscos-container">
                  <div class="border-riscos ">
                    <div class="Coluna-Detalhes-Resultado-Risco-parte1"  :style="isPdf === undefined || isPdf === !true ? 'width: 75%;' : 'width: 75%'">
                      <div class="risco-font-detalhe ml-3">{{dataCausa.causaDescricao}}</div>

                      <div class="barra" v-if="dataCausa.descricaoStatus !== null"></div>
                      <div class="tag" v-if="dataCausa.descricaoStatus !== null">
                        <div class="tag_identintificacao" :style="{'background-color': dataCausa.colorStatusAPR, 'color': dataCausa.colorStatusAPRFonte}">{{dataCausa.descricaoStatus}}</div>
                      </div>
                    </div>

                    <div class="Coluna-Detalhes-Resultado-Risco-parte2" :style="isPdf === undefined || isPdf === !true ? 'width: 15%;' : 'width: 25%'">
                      <div class="card1">
                        <div  b-v-tooltip.hover class="card-apr font-bold" :style="{'background-color': card, 'color': fontCard}">
                          {{dataCausa.severidadeDescricao}}
                        </div>
                      </div>

                      <div class="card1">
                      <div class="card-apr font-bold" :style="{'background-color': card, 'color': fontCard}">
                          {{dataCausa.probabilidadeDescricao}}
                        </div>
                      </div>

                      <div class="card1">
                        <div class="card-apr font-bold" :style="{'background-color': dataCausa.colorClassificacao == null ? 'red' : dataCausa.colorClassificacao, 'color': dataCausa.colorFonteClassificacao}">
                          {{dataCausa.classificacaoDescricao}}
                        </div>
                      </div>
                    </div>
                    <div v-if="isPdf === false || isPdf === undefined" class="Coluna-Detalhes-Resultado-Risco-parte3">
                      <div class="icone-visualizacao-risco icones" @click="popUpAprVisualizacao(item, index)"><i v-b-tooltip.hover :title="'Visualizar Detalhes de Risco'" class="fas fa-eye" style="color: #666666;;"></i></div>
                  </div>
                  </div>
                </div>
              </div>
              <div class="Informacao-Detalhes-template-pdf p-2" v-if="isPdf === true">
                  <div class="detalhe-pdf w-100">
                    <div class="w-50">
                      <div class="font">
                        Fonte Geradora
                      </div>
                      <div class="font-bold mt-2">
                        {{ dataCausa.fonteDescricao }}
                      </div>
                    </div>
                    <div class="w-30">
                      <div class="font">
                        Possíveis Consequências
                      </div>
                      <div class="font-bold mt-2">
                        {{ dataCausa.consequenciaDescricao }}
                      </div>
                    </div>
                  </div>
                <div class="mb-2">
                  <div class="font">
                    Medidas de Controle / Mitigadoras
                  </div>
                  <div class="font-bold mt-2">
                    {{ dataCausa.medidaDescricao }}
                  </div>
                </div>
              </div>
            </div>
          </div>
            </b-collapse>
          </b-card>
        </div>
      <b-modal ref="add-risco"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
        >
        <template #modal-title>
          <div class="header-title">APR</div>
        </template>
      <div>
        <div class="mt-2">
          <label class="label-search">Natureza do Risco</label>
          <b-form-input disabled v-model="riscoDescricao"></b-form-input>
        </div>
        <div>
          <div>
            <div class="mt-2" style="width: 100%;">
              <label class="label-search margin">Fonte Geradora</label>
              <b-form-input disabled v-model="item.fonteDescricao"></b-form-input>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div class="mt-2" style="width: 100%;">
              <label class="label-search margin">Possíveis Consequências</label>
              <b-form-input disabled v-model="item.consequenciaDescricao"></b-form-input>
            </div>
            </div>
              <div>
                <div style="width: 100%;">
                  <label class="label-search margin">Medidas de Controle / Mitigadoras</label>
                  <b-form-textarea disabled rows="8" v-model="item.medidaDescricao"></b-form-textarea>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
    </div>

  </template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import addRisk from '@/views/private/apr/templateApr/components/addRisk/addRisk.vue'

export default {
  props: ['propApr', 'isPdf'],
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {addRisk},
  data () {
    return {
      card: '#CBE9CF',
      aprTemplateAgAprovacao: false,
      fontCard: '#1C6228',
      aprVisualizacao: false,
      UpAprEdicao: false,
      TemplateAgAprovacao: false,
      idRisco: null,
      idCausa: null,
      revisaoPopUp: null,
      itensTemplate: {},
      avalicaoAgAprovacaotemplateId: null,
      avalicaoRiscoId: null,
      avalicaoCausaId: null,
      avalicaotemplateId: null,
      avalicaoRevisao: null,
      avalicaoMemoria: false,
      avalicaoP: null,
      causaAgEnvio: false,
      item: {},
      avalicaoS: null,
      avalicaoCR: null,
      dataTemplateAPR: [],
      riscoDescricao: null,
      openSections: []
    }
  },

  watch: {
  },

  mounted () {
  },
  methods: {
    async onLoad () {
      const params = new URLSearchParams(window.location.search)
      if (this.isPdf) {
        if (!this.propApr) return
        this.AprID = this.propApr.id
      } else {
        params.forEach((value) => {
          this.AprID = value
        })
      }
      loading.push()
      await AprAnalisePreliminarRisco.GetTemplate(this.AprID)
        .then((Response) => {
          loading.pop()
          this.dataTemplateAPR = Response.data.data
          console.log(this.dataTemplateAPR)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    popUpAprVisualizacao (value, index) {
      console.log(value)
      this.riscoDescricao = value.riscoDescricao
      this.item = {...value.itens[index]}
      this.$refs['add-risco'].show()
    },
    toggleSection (index) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    }
  }
}

</script>

    <style scoped>
    .head-mes {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding-right: 1rem;
    }
    .collapseApr {
      background-color: #008144;
      min-height: 2rem; /* Altura mínima de 2rem */
      height: fit-content; /* Ajusta a altura ao conteúdo */
      display: flex;
      border-radius: 0;
      width: 100%;
    }
    .pageBreak {
      /* break-after: avoid;
      break-before: avoid; */
      break-inside: avoid;
    }
    .button-novo-risco{
      font: normal normal 600 12px/24px Segoe UI;
      font-weight: bold;
    }
    .img_sem_risco{
      width: 24%;
      margin: 3rem;
    }
    .container_img_sem_risco{
      display: flex;
      padding: 1rem;
      justify-content: center;
    }
    .barra {
      border-left: 1px solid #d2d2d2;
      height: 2rem;
      margin: 0 10px 0 10px;
    }
    .Coluna-Detalhes-Resultado-Risco-parte3 {
      display: flex;
      justify-content: center;
      width: 10%;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .Coluna-Detalhes-Resultado-Risco-parte1 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .Coluna-Detalhes-Resultado-Risco-parte2 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .icone-novo-risco{
      display: flex;
      align-items: center;
      font-size: 10px;
      padding-right: 6px;
    }
    .icone-lixeira{
      font-size: 10px;
    }
    .Coluna-Detalhes-risco{
      border: 1px solid #d2d2d2;
      display: flex;
      width: 100%;
      height: 2rem;
      background-color: #f5f5f5;
    }
    .Coluna-Detalhes-risco-parte1 {
      display: flex;
      justify-content: flex-start;
      width: 75%;
      align-items: center;
      padding-left: 0.5rem;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .Coluna-Detalhes-risco-parte2 {
      display: flex;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
      background-color: #e4e5e6;
    }
    .Coluna-Detalhes-risco-parte3 {
      display: flex;
      width: 10%;
      align-items: center;
      height: 100%;
      border-right: 1px solid #d2d2d2;
    }
    .body{
      width: 100%;
    }
    .container-apr{
      /* break-before: avoid; */
      margin-bottom: 1rem;
    }
    .riscos-container{
      border: 1px solid #d2d2d2;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .border-meio-div{
      border-left: 1px solid #d2d2d2;
    }
    .border-riscos {
      display: flex;
      height: 3.5rem;
      align-items: center;
    }
    .risco-font-detalhe{
      color: #008144;
      font-family: 'Segoe UI';
      font-size: 14px;
      padding: 0 0 0 8px;
      width: fit-content;
    }
    .tag{
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-radius: 20px;
      height: 100%;
    }
    .tag_identintificacao{
      width: fit-content;
      height: 1.6rem;
      text-align: center;
      border-radius: 20px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      padding: 0 5px 0 5px;
      font-weight: bold;
    }
    .header-title{
      color: white;
      font-weight: bold;
      font-size: 16px;
      font-family: 'Segoe UI';
    }
    .icone-edicao-risco{
      display: flex;
      cursor: pointer;
      justify-content: end;
    }
    .icone-visualizacao-risco{
      display: flex;
      cursor: pointer;
      justify-content: end;
      scale: 1.5
    }
    .Header-Detalhes-Templete{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 2rem;
      background-color: #e4e5e6;
      border-right: 1px solid #c9c9c9;
    }
    .Colunas-Detalhes-template{
      align-items: center;
      justify-content: center;
      display: flex;
      width: 100%;
      height: 2rem;
    }
    .Informacao-Detalhes-template{
      display: flex;
      border: 1px solid #c9c9c9;
      justify-content: initial;
      align-items: center;
      width: 100%;
      height: fit-content;
    }
    .Informacao-Detalhes-template-pdf{
      display: flex;
      flex-direction: column;
      gap: 1rem;
      border: 1px solid #c9c9c9;
      justify-content: initial;
      align-items: flex-start;
      width: 100%;
      height: fit-content;
    }
    .detalhe-pdf{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
    .font-column{
      font-size: 12px;
      color: #008144;
      font-family: 'Segoe UI';
      font-weight: bold;
    }
    .font-column-matriz{
    font-size: 12px;
    /* background-color: #008144; */
    color: #666666;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: center;
  }
    .font-column-matriz-etapa{
    font-size: 16px;
    /* background-color: #008144; */
    color: white;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
  }
  .font{
        color: #666666;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .tipo-apr{
      color:#666666;
      width: 100%;
    }
    .add{
      width: 20%;
      cursor: pointer;
      display: flex;
      justify-content: end;
    }
    .exclur{
      width: 3%;
      cursor: pointer;
      display: flex;
      justify-content: end;
      align-items: center;
      color: white;
    }
    .card-container{
      display: flex;
      border-left: 1px solid #d2d2d2;
      align-items: center;
      height: 3.5rem;
      column-gap: 0.5rem;
      padding: 0 1rem;
    }
    .font-bold {
      font-size: 14px;
      font-weight: bold;
      color:#666666;
    }
    .cursor {
      cursor: pointer;
    }
    .card-apr{
      font-size: 12px;
      font-family: 'Segoe UI';
      border-radius: 5px;
      width: 2.2rem;
      height: 2.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .card1{
      display: flex;
      justify-content: center;
      width: 100%;
    }
    .icones {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .font_result {
        color: #1A1818;
        font-family:'Segoe UI';
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/details/components/detailsApr.vue